import StateHelper from "./StateHelper";
import {IncludeExclude, PageName, PageState, QueryFlags} from "./types";
import {UrlParser} from "./types";
import dayjs from ".//dayjs";
import { determineStartingDateMode } from "./DateUtil";

const urlParser: UrlParser = {

  getPageFromCurrentLocation : function(location : string) :  string{
    return location.substring(1,location.length).trim();
  },

  extractKeyAndValue: function (str: string) {
    let value = null;
    let valueArray = str.split("=");
    if (valueArray.length > 0) {
      value = { key: valueArray[0], value: valueArray[1] };
    }
    return value;
  },

  parseUrl: function (url: string, setActiveLink: (activeClink:string)=> void) {
    const pageState : PageState = StateHelper.getPageState();
    
    let array = decodeURI(url).split("?");

    //get page name
    const pageNamePart = array[0];
    const lastIndexOfBar = pageNamePart.lastIndexOf("/");

    // const pageName = pageNamePart.substring(lastIndexOfBar);
    const pageName = this.getPageFromCurrentLocation(pageNamePart.substring(lastIndexOfBar));
    pageState.page = pageName ? pageName : PageName.overall;
    setActiveLink(pageState.page);

    let values:{[key:string]:string}[] = [];

    pageState.dateStart = dayjs.utc();
    pageState.dateEnd = dayjs.utc();
    pageState.publishers = [];
    pageState.placements = [];
    pageState.placementsIncludeExclude = IncludeExclude.Include;
    pageState.trafficTypes = null;
    pageState.trafficTypesIncludeExclude = IncludeExclude.Include;
    pageState.countries = null;
    pageState.countriesIncludeExclude = IncludeExclude.Include;
    pageState.groupBy = null;
    pageState.productIds = null;
    pageState.productsIncludeExclude = IncludeExclude.Include;
    pageState.campaigns = null;
    pageState.campaignsIncludeExclude = IncludeExclude.Include;
    pageState.queryFlags =null;
    pageState.cLinks = null;
    pageState.cLinksIncludeExclude = IncludeExclude.Include;
    pageState.viewAs = null;
    pageState.pivotBy = null;

    if (array.length !== 2) {
      return ;
    }

    //save keys and values
    let parametersPart = array[1];

    let urlParameters = parametersPart.split("&");
    for (let i = 0; i < urlParameters.length; i++) {
      let str = urlParameters[i];
      let keyValue = this.extractKeyAndValue(str);
      if (keyValue !== null) {
        values.push(keyValue);
      }
    }

    //verify parameters and their names according to what we expect.
    //This is done because parameters can come in any order in the url.
    for (let i = 0; i < values.length; i++) {
      const element = values[i];

      switch (element.key) {
        case "dateStart":
          pageState.dateStart = dayjs.utc(element.value);
          break;
        case "dateEnd":
          pageState.dateEnd  = dayjs.utc(element.value);
          break;
        case "placementsInclude":
        case "placementsExclude":
          //if it has 3 elements is a placement, otherwise is as publisher.
          const elements : string[] = element.value.split(",");
          const publishersIds = [];
          const placementsIds : string[] = [];
          for (let i = 0; i < elements.length; i++) {
            const e : string = elements[i];
            const idsArray : string[] = e.split(":");
            const isPlacement : boolean = idsArray.length > 2;
            if (isPlacement) {
              placementsIds.push(e);
            } else {
              publishersIds.push(e);
            }
          }

          pageState.publishers = publishersIds;
          pageState.placements = placementsIds;
          pageState.placementsIncludeExclude = element.key === "placementsInclude" ? IncludeExclude.Include : IncludeExclude.Exclude;
        break;
        case "trafficTypesInclude":
          pageState.trafficTypes = element.value;
          pageState.trafficTypesIncludeExclude = IncludeExclude.Include;
          break;
        case "trafficTypesExclude":
          pageState.trafficTypes = element.value;
          pageState.trafficTypesIncludeExclude = IncludeExclude.Exclude;
          break;
        case "countriesInclude":
          pageState.countries = element.value;
          pageState.countriesIncludeExclude = IncludeExclude.Include;
          break;
        case "countriesExclude":
          pageState.countries = element.value;
          pageState.countriesIncludeExclude = IncludeExclude.Exclude;
          break;
        case "groupBy":
          pageState.groupBy = element.value;
          break;
        case "productsInclude":
          pageState.productIds = element.value ? element.value : "";
          pageState.productsIncludeExclude = IncludeExclude.Include;
          break;
        case "productsExclude":
          pageState.productIds = element.value ? element.value : "";
          pageState.productsIncludeExclude = IncludeExclude.Exclude;
          break;
        case "campaignsInclude":
          pageState.campaigns = element.value ? element.value.split(",") : [];
          pageState.campaignsIncludeExclude = IncludeExclude.Include;
          break;
        case "campaignsExclude":
          pageState.campaigns = element.value ? element.value.split(",") : [];
          pageState.campaignsIncludeExclude = IncludeExclude.Exclude;
          break;
        case "clinksInclude":
          pageState.cLinks = element.value ? element.value.split(",") : [];
          pageState.cLinksIncludeExclude = IncludeExclude.Include;
          break;
        case "clinksExclude":
          pageState.cLinks = element.value ? element.value.split(",") : [];
          pageState.cLinksIncludeExclude = IncludeExclude.Exclude;
          break;
        case "queryFlags":
          pageState.queryFlags = [];
          if (element.value) {
            element.value.split(",").forEach((qf) => {
              const newQueryFlag = Object.values(QueryFlags).find((value) => value === qf);
              if (newQueryFlag) {
                pageState.queryFlags.push(newQueryFlag);
              }
            });
          }
          break;
        case "viewAs":
          pageState.viewAs = element.value;
          break;
        case "pivotBy":
          pageState.pivotBy = element.value;
          break;
      }

      const groupByArr = pageState.groupBy == null ? [] : pageState.groupBy.split(",");
      pageState.dateMode = determineStartingDateMode(groupByArr, pageState.dateStart, pageState.dateEnd);
    }
  },
};


export default urlParser;
